import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { AddBankAccount } from './AddBankAccount';
import { ChooseBankAccount } from './ChooseBankAccount';
import { TwoFASetup } from './TwoFASetup';
import { WithdrawFinalCheck } from './WithdrawFinalCheck';
import { WithdrawInitial } from './WithdrawInitial';
import { WithdrawSuccess } from './WithdrawSuccess';
import { useAppSelector } from '../../../app/hooks';
import { Withdraw2FARequired } from './Withdraw2FARequired';
import { WithdrawAvailability } from './WithdrawAvailability';
import { WalletActivation } from './Withdraw.types';

import { wallets as networks } from '../../../helpers/helperFunctions';

interface WithdrawProps {
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  setWithdraw: Dispatch<SetStateAction<boolean>>;
}

export const Withdraw = ({ step, setStep, setWithdraw }: WithdrawProps) => {
  const [amount, setAmount] = useState('');
  const fee = 5;
  const [selectedWallet, setSelectedWallet] = useState<any>('');
  const [selectedNetwork, setSelectedNetwork] = useState<any>(networks[0]);
  const [selectedToken, setSelectedToken] = useState<any>();
  const [isWithdrawSelected, setIsWithdrawSelected] = useState<boolean>(false);

  const [selected, setSelected] = useState(0);

  const { wallets } = useAppSelector((state) => state.wallets);

  const { info } = useAppSelector((state) => state.earnings);

  useEffect(() => {
    const firstActiveWallet = wallets.find(
      (wallet: any) => wallet.status === WalletActivation.ACTIVE
    );

    setSelectedWallet(firstActiveWallet);
  }, [wallets]);

  return (
    <>
      {step === 1 && (
        <WithdrawInitial
          isWithdrawSelected={isWithdrawSelected}
          setIsWithdrawSelected={setIsWithdrawSelected}
          setStep={setStep}
          userWallets={wallets}
          selected={selected}
          amount={amount}
          setAmount={setAmount}
          info={info}
          selectedNetwork={selectedNetwork}
          setSelectedNetwork={setSelectedNetwork}
          selectedToken={selectedToken}
          setSelectedToken={setSelectedToken}
          selectedWallet={selectedWallet}
        />
      )}

      {step === 2 && (
        <WithdrawFinalCheck
          selectedToken={selectedToken}
          setStep={setStep}
          amount={amount}
          selected={selected}
          userWallets={wallets}
          selectedNetwork={selectedNetwork}
          setAmount={setAmount}
          networkType={selectedNetwork?.networkType}
        />
      )}
      {step === 3 && <WithdrawSuccess setWithdraw={setWithdraw} />}

      {step === 6 && (
        <TwoFASetup
          setStep={setStep}
          amount={amount}
          setAmount={setAmount}
          selected={selected}
          userWallets={wallets}
          fee={fee}
          networkType={selectedNetwork?.networkType}
          selectedToken={selectedToken}
        />
      )}
      {/* {step === 7 && (
        <VerificationEmail
          setStep={setStep}
          amount={amount}
          setAmount={setAmount}
          selected={selected}
          userWallets={userWallets}
          networkType={selectedNetwork.networkType}
        />
      )} */}
    </>
  );
};
